import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e5dafb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TripsList" }
const _hoisted_2 = { class: "flex items-center justify-end mt-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_5 = { class: "mt-4 bg-white rounded" }
const _hoisted_6 = { class: "flex items-center justify-end py-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_8 = { class: "TripsTable" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm text-gray-400 select-none"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка списка рейсов...", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении списка рейсов произошла ошибка", -1))
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 1,
  class: "TripsTable"
}
const _hoisted_14 = { class: "flex items-center justify-end pb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_trips_tms_actions = _resolveComponent("trips-tms-actions")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TripsTMSFilters = _resolveComponent("TripsTMSFilters")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_loader = _resolveComponent("loader")!
  const _component_trips_tms_row = _resolveComponent("trips-tms-row")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_trips_tms_actions, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          onCreate: _ctx.createTrip,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false))
        }, null, 8, ["loading", "onCreate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/tms/trips/create-bid" }, {
        default: _withCtx(() => [
          _createVNode(_component_new_button, { class: "NewButton--medium NewButton--square" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" Создать заявку ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.havePermissions(['tms.trip-store']))
        ? (_openBlock(), _createBlock(_component_new_button, {
            key: 0,
            loading: _ctx.actions_state.is_actions_loading,
            disabled: _ctx.actions_state.is_actions_loading,
            class: "NewButton--medium NewButton--square ml-2",
            onClick: _ctx.toggleCreateTrip
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" Создать рейс ")
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_TripsTMSFilters, {
      class: "mt-3",
      loading: _ctx.state.is_loading,
      disabled: _ctx.state.is_loading,
      onSubmit: _ctx.onFiltersChanged,
      onReset: _ctx.onFiltersReset
    }, null, 8, ["loading", "disabled", "onSubmit", "onReset"]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.havePermissions(['tms.trip-index']))
          ? (_openBlock(), _createBlock(_component_new_button, {
              key: 0,
              loading: _ctx.state.is_excel_loading,
              disabled: _ctx.state.is_excel_loading,
              class: "NewButton--medium NewButton--square mr-3",
              onClick: _ctx.downloadReportTrips
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_new_limit, {
          disabled: _ctx.state.is_loading,
          value: _ctx.state.pagination.limit,
          "total-items": _ctx.state.pagination.total_items,
          onChange: _ctx.onLimitChange
        }, null, 8, ["disabled", "value", "total-items", "onChange"]),
        _createVNode(_component_new_pagination, {
          class: "ml-6",
          disabled: _ctx.state.is_loading,
          "current-page": _ctx.state.pagination.page,
          "total-pages": _ctx.state.pagination.total_pages,
          onChangePage: _ctx.onChangePage
        }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.list.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.state.is_loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_loader, { class: "primary" }),
                    _hoisted_10
                  ], 64))
                : (_ctx.state.is_failed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_11,
                      _createVNode(_component_new_button, {
                        class: "mt-1",
                        onClick: _ctx.loadTrips
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Перезагрузить ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_ctx.state.list.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Список рейсов пуст"))
                    : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_new_table, {
                columns: _ctx.TABLE_COLUMNS,
                rows: _ctx.state.list
              }, {
                td: _withCtx(({ column, row }) => [
                  _createVNode(_component_trips_tms_row, {
                    column: column,
                    row: row,
                    index: _ctx.state.list.indexOf(row)
                  }, null, 8, ["column", "row", "index"])
                ]),
                _: 1
              }, 8, ["columns", "rows"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_new_limit, {
          disabled: _ctx.state.is_loading,
          value: _ctx.state.pagination.limit,
          "total-items": _ctx.state.pagination.total_items,
          onChange: _ctx.onLimitChange
        }, null, 8, ["disabled", "value", "total-items", "onChange"]),
        _createVNode(_component_new_pagination, {
          class: "ml-6",
          disabled: _ctx.state.is_loading,
          "current-page": _ctx.state.pagination.page,
          "total-pages": _ctx.state.pagination.total_pages,
          onChangePage: _ctx.onChangePage
        }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
      ])
    ])
  ]))
}